import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  Output,
  Renderer2,
} from '@angular/core';
// import { LMContextService } from '@app/services';

// import IdsPager from 'ids-enterprise-wc/components/ids-pager/ids-pager';
// import IdsPagerDropdown from 'ids-enterprise-wc/components/ids-pager/ids-pager-dropdown';
// import 'ids-enterprise-wc/components/ids-pager/ids-pager';
// import 'ids-enterprise-wc/components/ids-pager/ids-pager-button';
// import 'ids-enterprise-wc/components/ids-pager/ids-pager-dropdown';
// import 'ids-enterprise-wc/components/ids-layout-grid/ids-layout-grid';
// import 'ids-enterprise-wc/components/ids-layout-grid/ids-layout-grid-cell';

@Component({
  selector: 'lm-list-pager-wrapper',
  standalone: false,
  templateUrl: './lm-list-pager-wrapper.component.html',
  styleUrls: [ './lm-list-pager-wrapper.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMListPagerWrapperComponent implements AfterViewInit {
  @Input() enableFirstButton = false;
  @Input() enablePreviousButton = false;
  @Input() enableNextButton = false;
  @Input() enableLastButton = false;
  @Input() firstPageTooltip = '';
  @Input() previousPageTooltip = '';
  @Input() nextPageTooltip = '';
  @Input() lastPageTooltip = '';
  @Input() pageSize = 0;
  @Input() pageSizes = [];
  @Input() showPageSizeSelector = false;

  @Input() pagerId = '';
  @Input() automationId = '';
  @Input() attributes = [];

  @Output() firstPage: EventEmitter<LMListGridPagingEvent> = new EventEmitter<LMListGridPagingEvent>();
  @Output() previousPage: EventEmitter<LMListGridPagingEvent> = new EventEmitter<LMListGridPagingEvent>();
  @Output() nextPage: EventEmitter<LMListGridPagingEvent> = new EventEmitter<LMListGridPagingEvent>();
  @Output() lastPage: EventEmitter<LMListGridPagingEvent> = new EventEmitter<LMListGridPagingEvent>();
  @Output() pageSizeChange: EventEmitter<LMListGridPagingEvent> = new EventEmitter<LMListGridPagingEvent>();

  // @ViewChild('IdsPager') pagerElementRef!: ElementRef;
  // @ViewChild('IdsPagerDropdown', { static: false }) pagerDropdownElementRef!: ElementRef;

  // useWC = false;

  constructor(
    private ngZone: NgZone,
    private renderer2: Renderer2,
    // private lmContextService: LMContextService
  ) {
    // this.useWC = this.lmContextService.useWebComponents();
  }

  ngAfterViewInit() {
    // if (this.useWC && this.pagerElementRef) {
    //   this.ngZone.runOutsideAngular(() => {
    //     setTimeout(() => {
    //       const idsPager: IdsPager = this.pagerElementRef.nativeElement as IdsPager;
    //       if (!idsPager) {
    //         // throw 'idsPager is null';
    //         return;
    //       }
    //
    //
    //       // const idsPagerDropdown = new IdsPagerDropdown();
    //       // idsPagerDropdown.slot = 'end';
    //       // idsPagerDropdown.label = '';
    //       // idsPager.appendChild(idsPagerDropdown);
    //
    //       idsPager.pageSizes = this.pageSizes;
    //       idsPager.pageSize = this.pageSize;
    //
    //       // idsPager.setAttribute('data-automation-id', this.automationId);
    //       // idsPager.querySelector('ids-pager-button[first]')?.setAttribute('data-automation-id', this.automationId + '-first-button');
    //       // idsPager.querySelector('ids-pager-button[previous]')?.setAttribute('data-automation-id', this.automationId + '-previous-button');
    //       // idsPager.querySelector('ids-pager-button[next]')?.setAttribute('data-automation-id', this.automationId + '-next-button');
    //       // idsPager.querySelector('ids-pager-button[last]')?.setAttribute('data-automation-id', this.automationId + '-last-button');
    //       //
    //       // const pagerDropdownButton = idsPager.querySelector('ids-pager-dropdown');
    //       // pagerDropdownButton?.setAttribute('data-automation-id', this.automationId + '-pagesize-chooser-button');
    //       // pagerDropdownButton?.shadowRoot?.querySelector('ids-popup-menu')?.setAttribute('data-automation-id', this.automationId + '-pagesize-chooser-menu');
    //
    //       // idsPagerDropdown.popupMenu.positionStyle = 'relative';
    //
    //       this.renderer2.listen(idsPager, 'pagesizechange', (event) => this.ngZone.run(() => this.onPageSizeChange(event)));
    //
    //       // this should have worked in the template label="" but when using this
    //       // with an ngIf it fails to send the empty label string.
    //       const idsPagerDropdown: IdsPagerDropdown = this.pagerDropdownElementRef.nativeElement as IdsPagerDropdown;
    //       idsPagerDropdown.label = '';
    //     });
    //   });
    // }
  }

  onFirstPage($event: any) {
    this.firstPage.emit({ pageOp: 'first' });
  }

  onPreviousPage($event: any) {
    this.previousPage.emit({ pageOp: 'previous' });
  }

  onNextPage($event: any) {
    this.nextPage.emit({ pageOp: 'next' });
  }

  onLastPage($event: any) {
    this.lastPage.emit({ pageOp: 'last' });
  }

  onPageSizeChange($event: any) {
    const newEvent: LMListGridPagingEvent = { pageOp: 'pagesize' };
    // newEvent.pageSize = this.useWC ? ($event as CustomEvent).detail.value : $event[1].pagesize;
    newEvent.pageSize = $event[1].pagesize;
    this.pageSizeChange.emit(newEvent);
  }
}

